<!--

 -->

<template>
  <employee-autocomplete
    :label="$t('performance.key_performance_indicators_for_job_title')"
    :multiple="true"
    :clear="false"
    :create-options="loadJobTitle"
    required
  />
</template>

<script>
import EmployeeAutocomplete from '@/core/components/inputs/EmployeeAutocomplete';
import {APIService} from '@/core/util/services/api.service';

export default {
  name: 'JobTitleAutoComplete',
  components: {
    'employee-autocomplete': EmployeeAutocomplete,
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/job-titles',
    );
    return {
      http,
    };
  },
  methods: {
    async loadJobTitle(searchParam) {
      return new Promise((resolve) => {
        this.http.getAll({title: searchParam, limit: 0}).then(({data}) => {
          resolve(
            data.data.map((item) => {
              return {
                id: item.id,
                label: item.title,
              };
            }),
          );
        });
      });
    },
  },
};
</script>
